import { render, staticRenderFns } from "./NewThreadForm.vue?vue&type=template&id=04809ba7&scoped=true&"
import script from "./NewThreadForm.vue?vue&type=script&lang=js&"
export * from "./NewThreadForm.vue?vue&type=script&lang=js&"
import style0 from "./NewThreadForm.vue?vue&type=style&index=0&id=04809ba7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04809ba7",
  null
  
)

export default component.exports